import { provideHttpClient } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { ChatConfigService } from './core/chat/chat-config.service';
import { ChatHistoryService } from './core/chat/chat-history.service';
import { ChatSessionService } from './core/chat/chat-session.service';
import { ChatSocketService } from './core/chat/chat-socket.service';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    ChatConfigService,
    ChatHistoryService,
    ChatSessionService,
    ChatSocketService,
  ],
};
